


$w.onReady(function () {
    //TODO: write your page related code here...
    //var globalStatus;
   // $w('#currentPageButton').label = wixSite.currentPage.name;
//	$w('#currentPageText').text = wixSite.currentPage.name;
    //wixData.query("Top Menu").ne($w('#MenuHeaderRepeaterImage').tooltip,wixSite.currentPage.name);
    //console.log(vale);
    //console.log($w('#MenuHeaderRepeater').data.);
});




/**
*	Adds an event handler that runs when the mouse pointer is moved
 onto the element.

> **Deprecation note:** The $w parameter of event handlers is being deprecated. To get
 a scoped selector for working with elements in repeater items, use the [$w.at()]($w.html#at) function
 and pass it the context property of the event parameter: `$item = $w.at(event.context)`. To learn more, see
 [here](https://www.wix.com/velo/forum/wix-tips-and-updates/removal-of-the-w-parameter-from-event-handlers).

 You can also [define an event handler using the Properties and Events panel](https://support.wix.com/en/article/velo-reacting-to-user-actions-using-events).
*	 @param {$w.MouseEvent} event
*/
